import React, { useReducer } from "react";
import EmployeeContractTypeContext from "./EmployeeContractTypeContext";
import EmployeeContractTypeReducer from "./EmployeeContractTypeReducer";
import { getContractEmployeeTypesService } from "../../services/employees";

const EmployeeContractTypeState = ({ children }) => {

    const initialState = {
        contractEmployeeTypes: [],
        wasFetched: false
    }

    const [state, dispatch] = useReducer(EmployeeContractTypeReducer, initialState);

    const getContractEmployeeTypes = async () => {
        try {
            if (state.wasFetched === false) {
                const contractEmployeeTypes = await getContractEmployeeTypesService();
                if (contractEmployeeTypes.ok) {
                    dispatch({
                        type: 'GET_ALL_CONTRACT_EMPLOYEE_TYPES',
                        payload: contractEmployeeTypes.data.response
                    });
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <EmployeeContractTypeContext.Provider
            value={{
                employeeContractTypeState: state,
                getContractEmployeeTypes
            }}>
            {children}
        </EmployeeContractTypeContext.Provider>
    )
}

export default EmployeeContractTypeState